<template>
  <el-dialog
    v-model="visible"
    :title="dialogConfig.type ? '新建' : '编辑'"
    width="60%"
    :close-on-click-modal="false"
  >
    <el-form :model="formData" :rules="rules" ref="ruleRef" label-width="120">
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="物料名称：" prop="name">
            <el-input
              v-model="formData.name"
              v-no-space
              placeholder="请输入名称"
              :maxlength="20"
            /> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="物料编号：" prop="number">
            <el-input
              v-model="formData.number"
              placeholder="请输入编号"
              :maxlength="40"
            /> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="物料类别：" prop="categoryId">
            <el-select v-model="formData.categoryId" style="width: 100%">
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="品牌：" prop="brand">
            <el-select v-model="formData.brand" style="width: 100%">
              <el-option
                v-for="item in brandList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="规格型号：" prop="model">
            <el-select v-model="formData.model" style="width: 100%">
              <el-option
                v-for="item in modelList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="供应商：" prop="supplier">
            <el-input
              v-model="formData.supplier"
              v-no-space
              :maxlength="20"
              placeholder="请输入供应商"
            /> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="单位：" prop="unit">
            <el-input
              v-model="formData.unit"
              v-no-space
              placeholder="请输入单位"
              :maxlength="10"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col>
          <el-form-item label="备注：" prop="remark">
            <el-input
              type="textarea"
              :rows="5"
              v-model="formData.remark"
              :maxlength="200"
              show-word-limit
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSUbmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, toRefs } from "vue";
import useCateGoryList from "../../hooks/useCategoryList";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import {
  queryMaterielById,
  insertMateriel,
  updateMateriel,
} from "@/api/materiel";
import { ElMessage } from "element-plus";

const { categoryList } = useCateGoryList();

// 事件传递
const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 表单ref
const ruleRef = ref(null);

// 弹窗参数
const dialogConfig = ref({});

// 品牌list
const brandList = ref([]);

// 信号list
const modelList = ref([]);

// 按钮防抖
const buttonLoading = ref(false);

// 表单
const formData = ref({
  name: "",
  number: "",
  categoryId: "",
  brand: "",
  model: "",
  supplier: "",
  remark: "",
  unit: "",
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
  number: [
    { required: true, message: "请输入物料编号", trigger: "blur" },
  ],
  categoryId: [{ required: true, message: "请选择物料类别", trigger: "blur" }],
});

// 弹窗保存
const handleSUbmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      if (dialogConfig.value.type) {
        addMateriel(formData.value);
      } else {
        editMateriel(formData.value);
      }
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 获取字典数据
const getDictList = () => {
  queryDictList(DICT_KEY["brand"]).then((res) => {
    brandList.value = res.data || [];
  });
  queryDictList(DICT_KEY["model"]).then((res) => {
    modelList.value = res.data || [];
  });
};

// 新增
const addMateriel = (req) => {
  insertMateriel(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 编辑
const editMateriel = (req) => {
  updateMateriel(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 通过id获取数据
const getDataById = (id) => {
  queryMaterielById(id).then((res) => {
    let keys = Object.keys(res.data);
    Object.entries(formData.value).forEach((item) => {
      if (keys.includes(item[0])) {
        formData.value[item[0]] = res.data[item[0]];
      }
    });
    formData.value.brand = formData.value.brand
      ? formData.value.brand * 1
      : null;
    formData.value.model = formData.value.model
      ? formData.value.model * 1
      : null;
    formData.value.id = res.data.id;
  });
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = { ...config };
  getDictList();
  ruleRef.value?.resetFields();
  if (config.type) {
    formData.value = {
      name: "",
      number: "",
      categoryId: "",
      brand: "",
      model: "",
      supplier: "",
      remark: "",
      unit: "",
    };
  } else {
    getDataById(config.row.id);
  }
  visible.value = true;
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
